
(function($){

	$.fn.mcubeGmaps = function( options ){

		var defauts = {
			bounds:                     true, // active le centrage automatiquement de la map afin d'afficher tous les points dans le viewport
			overlay:                    true, // active l'apparition de la 'popup' au click sur le pointeur
			styles:                     null, // personnalisation des styles la map
			zoomControl:                true,
			zoomControlOptionsPosition: google.maps.ControlPosition.TOP_LEFT,
			mapTypeOptionsPosition:     google.maps.ControlPosition.LEFT_TOP,
			scrollwheel:                false,
			streetViewControl:          true,
			fullscreenControl:          true,
			mapTypeControl:             true,
			markers:                    null,
			markerCluster:              false
		};

		var parametres = $.extend(defauts, options);
		var overlayActive = false;

		if( typeof GMaps == "undefined" ){
			console.log('ERREUR GMAPS : activer GMaps dans functions.php','#FA3348','#ffffff');
		} 

		return this.each(function(){

			var $map             = $(this);
			var map              = false;
			var mapLat           = $map.data('lat');
			var mapLng           = $map.data('lng');
			var mapZoom          = ( $map.data('zoom') || 12 );
			var markers_item     = ( parametres.markers ) ? $(parametres.markers) : $('.map-markers', $map);
			var cpt              = 0;
			var markers          = [];
			var pointer          = $map.data('pointer');
			var pointerSize      = $map.data('pointer-size');
			var pointerHover     = $map.data('pointer-hover');
			var pointerHoverSize = $map.data('pointer-hover-size');
			
			if( parametres.markerCluster ){
				var markerCluster          = null;
				var pointerClusterer       = $map.data('pointer-clusterer');
				var pointerClustererSize   = $map.data('pointer-clusterer-size').split('x');
				var pointerClustererWidth  = pointerClustererSize[0];
				var pointerClustererHeight = pointerClustererSize[1];
				var pointerClustererHover  = $map.data('pointer-clusterer-hover');

				var styles_clusterer = [[{
			        url: pointerClusterer,
			        width: pointerClustererWidth,
			        height: pointerClustererHeight,
			        textColor: '#fff',
			        textSize: 1
			    }]];

				var options_clusterer = {
					gridSize: 20,
					styles: styles_clusterer[0],
					enableRetinaIcons: true,
					showCluster: function(){
						console.log('Adding cluster');
					}
		        };

		        function changeClusterIcon(the_marker, action){
					var clusters = markerCluster.getClusters();
					for( var i = 0, l = clusters.length; i <l ; i++ ) { // door de clusters heenlopen
			            for( var j=0, le = clusters[i].markers_.length; j < le; j++ ){ // door de markers heenlopen die in het cluster zitten
			                marker = clusters[i].markers_[j];
			                if(marker.id == the_marker.id) { // checken of we bij het juiste pieletje zijn
			                    clusters[i].clusterIcon_.styles_[0].url = (action == 'in') ? pointerClustererHover : pointerClusterer;
			                    clusters[i].updateIcon_();
			                }
			            }
			        }
				}
			}

			var bounds       = null;

			if( !mapLat && !parametres.bounds ){
				console.log('ERREUR GMAPS : définir une latitude (data-lat)','#FA3348','#ffffff');
			}

			if( !mapLng && !parametres.bounds ){
				console.log('ERREUR GMAPS : définir une longitude (data-lng)','#FA3348','#ffffff');
			}

			map = new GMaps({
				div:               "."+$(this).attr('class'),
				zoom:              mapZoom,
				// maxZoom:        13,
				lat:               mapLat,
				lng:               mapLng,
				scrollwheel:       parametres.scrollwheel,
				zoomControl:       parametres.zoomControl,
				zoomControlOptions: {
			        position: parametres.zoomControlOptionsPosition
			    },
				panControl:        true,
				streetViewControl: parametres.streetViewControl,
				fullscreenControl: parametres.fullscreenControl,
				mapTypeControl:    parametres.mapTypeControl,
				mapTypeControlOptions: {
					position: parametres.mapTypeOptionsPosition
				},
				options: {
					'styles': parametres.styles
				}
			});

			// google.maps.event.addListener(map.map, 'idle', function(event){
			// 	$('.offer-item').matchHeight('remove');
			// 	if( parametres.bounds ){
			// 		var markerVisible = 0;
			// 		$.each(markers, function(i, marker){

			// 			markers[i].setVisible(true);

			//             if( $('select[name="s_categorie"]').val() != "" ){
			//             	var category = $('select[name="s_categorie"]').val();
			//             	var offer = $('.offer-item[data-id='+markers[i].id+']');
			//             	if( offer.data('categorie') != category ){
			// 	            	markers[i].setVisible(false);
			// 	            }
			//             }

			// 			if ( map.getBounds().contains(markers[i].getPosition()) && markers[i].getVisible() ){
			//             	$('.offer-item[data-id='+markers[i].id+']').parent('div').removeClass('offer-item--hidden');
			// 	            markerVisible++;
			//             } else {
			//             	$('.offer-item[data-id='+markers[i].id+']').parent('div').addClass('offer-item--hidden');
			// 	            markerVisible--;
			//             }

			// 		});

			// 		if( markerCluster ){
			// 			markerCluster.setIgnoreHidden(true);
			// 			markerCluster.repaint();
			// 		}

			// 		$(document.body).trigger("sticky_kit:recalc");

			// 		$('.offer-item').matchHeight({
			// 			byRow : false
			// 		});

			// 		if( markerVisible < markers.length ){
			// 			$('.jobs-sidebar-map__show-all').addClass('jobs-sidebar-map__show-all--is-visible');
			// 		}else{
			// 			$('.jobs-sidebar-map__show-all').removeClass('jobs-sidebar-map__show-all--is-visible');
			// 		}

			// 		$('.jobs-sidebar-map__show-all').on('click', function(){
			// 			resetMap();
			// 		});

			// 	}
			// });

			var resetMap = function(){				
				$('.jobs-search-form').trigger("reset");
				$('select[name="s_categorie"]').val("").trigger('change');
				map.panToBounds(bounds);
				map.fitBounds(bounds);
			}

			var marker_counter = 0;
			var getGeocodeMarker = function(){

				var marker      = objectMarkers.markers[marker_counter];
				var searchValue = marker.address.split(' ').join('+');

				GMaps.geocode({
					address: searchValue,
					callback: function(results, status) {

						if ( status === "ZERO_RESULTS" || status === "INVALID_REQUEST" || status === "OVER_QUERY_LIMIT" ){

						}else{

							latlng = results[0].geometry.location;
							latPoint = latlng.lat();
							lngPoint = latlng.lng();

							addMarker(latPoint, lngPoint, marker );
							marker_counter++;

							if( marker_counter < objectMarkers.markers.length ){
								getGeocodeMarker();
							}

						}

					}
				});

			};

			var getMarkers = function(){

				var marker      = objectMarkers.markers[marker_counter];

				addMarker(marker['lat'], marker['lng'], marker );
				marker_counter++;

				if( marker_counter < objectMarkers.markers.length ){
					getMarkers();
				}

			};

			if( $("#_s_localisation").length > 0 ){

				var autocomplete, places;
				var countryRestrict = {'country': 'fr'};

				autocomplete = new google.maps.places.Autocomplete(
					document.getElementById('_s_localisation'), {
					types: ['(cities)'],
					componentRestrictions: countryRestrict
				});
				document.getElementById('_s_localisation').placeholder = '';

				autocomplete.addListener('place_changed', onPlaceChanged);

				$("#_s_localisation").on('keyup', function(){
					if( $(this).val() === "" ){
						map.panToBounds(bounds);
						map.fitBounds(bounds);
					}
				});

				function onPlaceChanged() {
					var place = autocomplete.getPlace();
					if (place.geometry) {
						map.panTo(place.geometry.location);
						map.setZoom(11);
					} else {
						document.getElementById('_s_localisation').placeholder = '';
					}
				}

			}

			var getGeocode = function(searchValue){

				GMaps.geocode({
					address: searchValue,
					callback: function(results, status) {

						if ( status === "ZERO_RESULTS" || status === "INVALID_REQUEST" || status === "OVER_QUERY_LIMIT" ){

							map.panToBounds(bounds);
							map.fitBounds(bounds);

						}else{

							latlng = results[0].geometry.location;
							latPoint = latlng.lat();
							lngPoint = latlng.lng();

							map.setCenter( latPoint, lngPoint );
							map.setZoom(11);

						}

					}
				});

			};

			/// Personnalisation du pointer
			if( pointer ){
				if( !pointerSize ){
					console.log('ERREUR GMAPS : spÃ©cifier les dimensions du pointer (data-pointer-size="WxH")','#FA3348','#ffffff');
				}
				imageSize   = pointerSize.split('x');
				imageWidth  = parseInt(imageSize[0]);
				imageHeight = parseInt(imageSize[1]);

				var icon = {
					url:        pointer,
					size:       new google.maps.Size( imageWidth , imageHeight ),
					origin:     new google.maps.Point( 0 , 0 ),
					anchor:     new google.maps.Point( imageWidth/2 , imageHeight ),
					scaledSize: new google.maps.Size( imageWidth , imageHeight )
				};

			}

			if( pointerHover ){
				if( !pointerHoverSize ){
					console.log('ERREUR GMAPS : spÃ©cifier les dimensions du pointer au survol (data-icon-hover-size="WxH")','#FA3348','#ffffff');
				}
				imageHoverSize   = pointerHoverSize.split('x');
				imageHoverWidth  = parseInt(imageHoverSize[0]);
				imageHoverHeight = parseInt(imageHoverSize[1]);

				var custom_iconHover = {
					url:        pointerHover,
					size:       new google.maps.Size( imageHoverWidth , imageHoverHeight ),
					origin:     new google.maps.Point( 0 , 0 ),
					anchor:     new google.maps.Point( imageHoverWidth/2 , imageHoverHeight ),
					scaledSize: new google.maps.Size( imageHoverWidth , imageHoverHeight )
				};
			}

			if( parametres.bounds ){
				bounds = new google.maps.LatLngBounds();
			}

			/// Ajout des markers
			var addMarker = function( lat, lng, marker ){

				var custom_icon = null;

				if( marker.pointer ){

					var custom_icon_url  = marker.pointer;
					var custom_icon_size = marker.pointer_size;

					custom_icon          = {
						url:        custom_icon_url,
						size:       new google.maps.Size( imageWidth , imageHeight ),
						origin:     new google.maps.Point( 0 , 0 ),
						anchor:     new google.maps.Point( imageWidth/2 , imageHeight ),
						scaledSize: new google.maps.Size( imageWidth , imageHeight )
					};

				}

				var myMarker = map.addMarker({
					id:      marker.id,
					lat:     lat,
					lng:     lng,
					content: marker.content,
					icon:    ( custom_icon || icon ),
					click:   function(element){
						if( parametres.overlay ){
							mapLoadOverlay( element );
						}
						if( marker.url ){
							window.location = marker.url;
						}
					}
				});

				myMarker.addListener('mouseover', function() {
				    $(parametres.markers+"[data-id="+this.id+"]").addClass('marker--over');
				    if( custom_iconHover ){
				    	this.setIcon( custom_iconHover );
				    }
				});

				myMarker.addListener('mouseout', function() {
				    $(parametres.markers+"[data-id="+this.id+"]").removeClass('marker--over');
				    this.setIcon( icon );
				});

				markers.push( myMarker );

				/// Recentre la map pour afficher tous les markers dans le viewport
				if( parametres.bounds && objectMarkers.markers.length > 1 ){
					bounds.extend( myMarker.getPosition() );
					map.panToBounds(bounds);
					map.fitBounds(bounds);
				}else if(objectMarkers.markers.length === 1 && !parametres.bounds){
					map.setCenter( lat, lng );
				}

				if( objectMarkers.markers.length === marker_counter + 1 ){
					if( parametres.markerCluster ){
						markerCluster = new MarkerClusterer(map.map, markers, options_clusterer);
					}
				}

			};

			var objectMarkers = {};
			objectMarkers.markers = [];

			if( markers_item.length > 0 ){

				var geocode = false;

				$.each(markers_item, function(i, marker){
					$this = $(this);

					marker            = [];
					marker['id']      = $this.data('id');
					marker['content'] = $this.find('.marker-overlay').html();

					if( $this.data('address') !== undefined ){

						geocode = true;

						marker['address'] = $this.data('address');
						marker['url']     = $this.data('link');
						if( $this.data('pointer') ){
							marker['pointer']      = $this.data('pointer');
							marker['pointer_size'] = $this.data('pointer-size');
						}
						objectMarkers.markers.push( marker );

					}else{

						if( $this.data('lat') !== "" ){
							marker['lat'] = $this.data('lat');
							marker['lng'] = $this.data('lng');
							objectMarkers.markers.push( marker );
						}else{
							console.log("attention un marqueur n'a pas de coordonnées");
						}

					}

				});

				if( geocode ){
					getGeocodeMarker();
				}else{
					getMarkers();
				}

		  //       $(parametres.markers).mouseenter(function() {
				// 	var coach_id = $(this).data('id');
				// 	for ( var i = 0; i< markers.length; i++) {
				// 		if ( coach_id === markers[i].id) {
				// 			changeClusterIcon(markers[i], 'in');
				// 			markers[i].setIcon( custom_iconHover );
				// 			break;
				// 		}
				// 	}
				// });

				// $(parametres.markers).mouseleave(function() {
				// 	var coach_id = $(this).data('id');
				// 	for ( var i = 0; i< markers.length; i++) {
				// 		if ( coach_id === markers[i].id) {
				// 			changeClusterIcon(markers[i], 'out');							
				// 			markers[i].setIcon( icon );
				// 			break;
				// 		}
				// 	}
				// });

			}else{

				marker            = [];
				marker['id']      = 0;
				marker['address'] = "";
				addMarker( mapLat, mapLng, marker );

			}

			/// Affichage des infos bulles
			var mapLoadOverlay = function(element){

				overlayActive = true;

				marker     = element;
				position   = marker.getPosition();
				marker_lat = position.lat();
				marker_lng = position.lng();

				contenu = '<div class="map-overlay"><div class="map-overlay-content"><a href="#" class="map-overlay-close"></a>';
				contenu += '<div class="map-overlay-inner">'+marker.content+'</div>';
				contenu += '</div></div>';

				map.removeOverlays();

				map.setCenter(marker_lat, marker_lng);
				
				var imgLoad = imagesLoaded( $(contenu) );
				imgLoad.on( 'always', function() {
					map.drawOverlay({
						lat:              marker_lat,
						lng:              marker_lng,
						verticalAlign:    'center',
						horizontalOffset: 20,
						layer:            'floatPane',
						content:          contenu
					});
				});

				$('.map-overlay a:not(.map-overlay-close)').unbind('click').click(function(e) {
					e.preventDefault();
					linkHandler( $(this) );
				});

				$(document).on('click touchstart', '.map-overlay-close', function(e) {
					e.preventDefault();
					map.removeOverlays();
					overlayActive = false;

					if( parametres.bounds ){
						map.panToBounds(bounds);
						map.fitBounds(bounds);
					}
				});

			}

			$('.operation-filters li').on('click', function(){
				setTimeout(function(){
					$.each(markers, function(i, marker){
						ID = markers[i].id;
						markers[i].setVisible(false);
						if( $(parametres.markers+"[data-id="+ ID +"]").parent().is(":visible") ){
							markers[i].setVisible(true);
						}
					});
				}, 700 );
			});

			$('select[name="s_categorie"]').change(function(){
				google.maps.event.trigger(map.map, 'idle');
			});

			$("#jobs-search-form").on('submit', function(){
				// var value = $('input[name="s_localisation"]').val();
				// getGeocode( value );
				return false;
			});

		});

	};

})(jQuery);